import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HomeComponent } from './features/home/components/home.component';
import { NpsLoginComponent } from './features/home/components/login.component';
import { NpsLogoutComponent } from './features/home/components/logout.component';
import { NpsLayoutLiteComponent } from './features/layout/components/nps.layout-lite.component';
import { NpsLayoutComponent } from './features/layout/components/nps.layout.component';
import { NpsGuard } from "./services/nps-auth.service";

const routes: Routes = [
  {
    path: 'nps', component: NpsLayoutComponent,
    canActivate: [NpsGuard],
    children: [
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'projects', loadChildren: () => import('./features/projects/projects.module').then(m => m.ProjectsModule) },
    ]
  },
  {
    path: 'nps/network-requests',
    canActivate: [NpsGuard],
    loadChildren: () => import('./features/network-requests/network-request.module').then(m => m.NetworkRequestModule)
  },
  {
    path: '', component: HomeComponent
  },
  {
    path: 'nps/login', component: NpsLayoutLiteComponent,
    children: [
      { path: '', component: NpsLoginComponent },
    ]
  },
  {
    path: 'nps/logout', component: NpsLayoutLiteComponent,
    children: [
      { path: '', component: NpsLogoutComponent },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes), 
  ],
  exports: [RouterModule]
})
export class NpsRoutingModule {}
